import { getMessage } from '../../../util/IntlMessages'
export const DATE_FORMAT = 'DD-MM-YYYY'

export const REPORT_TYPE = [
  { value: 'CADASTRO_ELEITOS', description: 'Cadastro de Agricultores e Locais' },
  { value: 'VISITAS', description: 'Relatório de Visitas' },
  { value: 'VISITAS_DETALHADA', description: 'Relatório de Visitas Detalhada' },
  { value: 'ELEITOS_E_ALTERNATIVOS', description: 'Grupos e Alternativos' },
  { value: 'FORECAST', description: 'Relatório de Forecast' },
  { value: 'CARGA_DE_DADOS', description: 'Histórico de Carga de Dados' },
  { value: 'CARTEIRA_DE_ELEITOS', description: 'Carteira de Agricultores' },
  { value: 'ARRASTAO', description: 'Relatório de Arrastão' },
  { value: 'ACTION_PLAN', description: 'Acompanhamento dos Planos de Ações' }
  // { value: 'PRODUCTIVITY', description: 'Relatório de Produtividade' }, Note: Disabled due to client request
]

export const STATUS = [
  { value: 'NAO_PLANEJADA', description: getMessage('report_action.status.notPlaning') },
  { value: 'PLANEJADA', description: getMessage('report_action.status.planing') },
  { value: 'REALIZADA', description: getMessage('report_action.status.Fulfilled') }
]

export const TIPO_IMPORTACAO = [
  { value: 2, description: getMessage('report.acoesexecutadas') },
  { value: 1, description: getMessage('report.pontuacaoagricultores') }
]

export const STATUS_IMPORTACAO = [
  { value: 6, description: getMessage('status.error') },
  { value: 5, description: getMessage('status.processing') },
  { value: 7, description: getMessage('status.finished') }
]
